module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact__map"
  }, [_c('div', {
    ref: "gmaps",
    staticClass: "gmaps",
    attrs: {
      "id": "gmaps"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a7df6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 258
// module chunks = 0